import * as React from 'react';
import { Builder } from '@builder.io/react';
import image from '@/assets/images/cms/buyButton.svg?inline';

export interface BuyButtonComponentProps {
	readonly buttonVariant?: 'primary' | 'round';
	readonly products: SelectedProduct[];
}

export interface SelectedProduct {
	readonly id: string;
	readonly segmentId: string;
}

const register = <TProps extends BuyButtonComponentProps>(Component: React.FC<TProps>): void => {
	Builder.registerComponent(Component, {
		name: 'BuyButton',
		image,
		inputs: [
			{
				type: 'Bizzkit ECS Product List',
				name: 'products',
			},
			{
				name: 'buttonVariant',
				type: 'string',
				enum: ['primary', 'round'],
				defaultValue: 'primary',
			},
		],
	});
};

export default register;
